/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from "react";
import "../../AdminScreens/AttendanceSheet/AttendanceSheet.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import axios from "axios";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Header from "../../../Components/Dashboard/Header/Header";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Components/loader/loader";
import { FaEdit } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { Button, Offcanvas } from "react-bootstrap";
import { IoIosFunnel } from "react-icons/io";

function OffCanvasExample({
  setShow,
  show,
  setActiveButton,
  handleAttendanceSearch,
  currentDate,
  setSearchAttendance,
  searchAttendance,
  activeButton,
  userOptions,
  ...props
}) {
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="HideButton-on-web" variant="primary" onClick={handleShow}>
        <IoIosFunnel />
      </Button>

      <Offcanvas
        className="Offcanvas-main-container"
        show={show}
        onHide={handleClose}
        {...props}
      >
        <Offcanvas.Header className="Offcanvas-outter-container" closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="Offcanvas-Body-container">
          <div className="Offcanvas-close-popup-forEMp-attendance">
            <div className="Offcanvas-Div" onClick={handleClose}></div>
          </div>

          <div className="calender-in-header-for-mobile-view row">
            <div className="col-4">
              <div className="EMP-flash-floating-sheet col">
                <label>Select User</label>
                <select
                  className="attendance-select-field"
                  value={searchAttendance?.UserId || ""}
                  onChange={(e) => {
                    const selectedUserId = e.target.value
                      ? Number(e.target.value)
                      : null;

                    setSearchAttendance((prev) => ({
                      ...prev,
                      UserId: selectedUserId,
                    }));

                    setActiveButton(1);

                    handleAttendanceSearch({
                      startDate: searchAttendance?.startDate,
                      endDate: searchAttendance?.endDate,
                      UserId: selectedUserId,
                    });
                  }}
                >
                  <option value="">All Users</option>
                  {userOptions?.map((user) => (
                    <option key={user.UserId} value={user.UserId}>
                      {user.UserName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-4">
              <div className="EMP-flash-floating-sheet col">
                <label>Choose start date</label>
                <input
                  type="date"
                  value={searchAttendance?.startDate}
                  onChange={(e) =>
                    setSearchAttendance((prev) => ({
                      ...prev,
                      startDate: e?.target?.value,
                    }))
                  }
                  max={currentDate}
                />
              </div>
            </div>

            <div className="col-4">
              <div className="flash-floating-sheet col">
                <label>Choose end date</label>
                <input
                  type="date"
                  value={searchAttendance?.endDate}
                  onChange={(e) =>
                    setSearchAttendance((prev) => ({
                      ...prev,
                      endDate: e?.target?.value,
                    }))
                  }
                  min={searchAttendance?.startDate}
                  max={currentDate}
                />
              </div>
            </div>

            {activeButton ||
            searchAttendance?.startDate ||
            searchAttendance?.endDate ||
            searchAttendance?.UserId ? (
              <div className="EMP-search-button-sheet col-12 mt-2">
                <button
                  onClick={() => {
                    setSearchAttendance({
                      startDate: "",
                      endDate: "",
                      UserId: null,
                    });
                    setActiveButton(undefined);
                    handleAttendanceSearch({
                      startDate: "",
                      endDate: "",
                      UserId: null,
                    });
                  }}
                >
                  Reset
                </button>
              </div>
            ) : null}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

const AttendanceSheet = () => {
  const navigate = useNavigate();
  const LoginToken = GetToken();

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [activeButton, setActiveButton] = useState();
  const [showSidebar, setShowSidebar] = useState(true);

  const [searchAttendance, setSearchAttendance] = useState({
    startDate: "",
    endDate: "",
    UserId: null,
  });

  const [getAttendance, setGetAttendance] = useState([]);
  const [dummyData, setDummyData] = useState([]);
  const [monthResult, setMonthResult] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [updateAttend, setupdateAttend] = useState(null);
  const [Modaldata, setmodaldata] = useState(null);
  const [modaldatanew, setmodaldatanew] = useState(null);
  const [isWFH, setIsWFH] = useState(false);

  const [IsExtraInTime, setIsExtraInTime] = useState("");
  const [IsExtraOutTime, setIsExtraOutTime] = useState("");
  const [selectedDailyStatus, setSelectedDailyStatus] = useState("");
  const [showExtraTimePopup, setshowExtraTimePopup] = useState(false);
  const [showFullDayConfirmation, setShowFullDayConfirmation] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showExtraListModal, setShowExtraListModal] = useState(false);
  const [selectedExtraList, setSelectedExtraList] = useState([]);
  const [editingExtraTime, setEditingExtraTime] = useState(null);
  const [editExtraInTime, setEditExtraInTime] = useState("");
  const [editExtraOutTime, setEditExtraOutTime] = useState("");
  const [showDeleteExtraModal, setShowDeleteExtraModal] = useState(false);
  const [deleteExtraId, setDeleteExtraId] = useState(null);

  const currentDate = new Date().toISOString().split("T")[0];

  const monthsArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const safeToDate = (value) => {
    if (!value) return null;

    try {
      if (value instanceof Date) return value;
      if (typeof value?.toDate === "function") return value.toDate();

      const converted = new Date(value);
      return Number.isNaN(converted.getTime()) ? null : converted;
    } catch {
      return null;
    }
  };

  const getMonthLabel = (records) => {
    if (!records || !records.length || !records[0]?.Date) return "";
    const firstDate = new Date(records[0].Date);
    if (Number.isNaN(firstDate.getTime())) return "";
    return `${monthsArray[firstDate.getMonth()]} ${firstDate.getFullYear()}`;
  };

  const groupByDateWithPunch = (records) => {
    const grouped = {};
    records?.forEach((item) => {
      if (!item?.Date) return;
      const dateKey = moment(item.Date).format("YYYY-MM-DD");
      if (!grouped[dateKey]) grouped[dateKey] = { main: null, extras: [] };
      if (item.IsMainPunch === false || item.IsExtraTime === true) {
        grouped[dateKey].extras.push(item);
      } else {
        grouped[dateKey].main = item;
      }
    });
    return Object.values(grouped);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Absent":
        return "status-absent";
      case "Holiday":
        return "status-holiday";
      case "WeeklyOFF":
        return "status-weekoff";
      case "SickLeave":
        return "status-sick";
      case "CasualLeave":
        return "status-casual";
      case "HalfDayleave":
      case "HalfDayLeave":
        return "status-halfday";
      case "ShortLeave":
        return "status-shortleave";
      case "ThreeQuareterLeave":
      case "ThreeQuarterLeave":
        return "status-shortwork";
      case "Od":
      case "OD":
      case "OutdoorDuty":
        return "status-outdoor";
      case "FullDay":
      case "Present":
      case "WFH":
        return "status-present";
      default:
        return "";
    }
  };

  const handlePencilClick = (item) => {
    setupdateAttend(item);
    setIsWFH(item?.Status === "WFH");

    const timeToDate = (timeString) => {
      if (!timeString) return null;

      const cleanTime = timeString?.split(".")?.[0];
      const timeArray = cleanTime?.split(":");
      if (!timeArray || timeArray.length < 2) return null;

      const date = new Date();
      date.setHours(parseInt(timeArray[0], 10) || 0);
      date.setMinutes(parseInt(timeArray[1], 10) || 0);
      date.setSeconds(parseInt(timeArray[2], 10) || 0);
      date.setMilliseconds(0);
      return date;
    };

    const inTime = timeToDate(item?.InTime);
    const outTime = timeToDate(item?.OutTime);

    setmodaldata(inTime);
    setmodaldatanew(outTime);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setupdateAttend(null);
    setmodaldata(null);
    setmodaldatanew(null);
    setIsWFH(false);
  };

  const CloseExtraTimeModal = () => {
    setshowExtraTimePopup(false);
    setIsExtraInTime("");
    setIsExtraOutTime("");
  };

  const openExtraTimeListModal = (extras) => {
    setSelectedExtraList(extras || []);
    setEditingExtraTime(null);
    setEditExtraInTime("");
    setEditExtraOutTime("");
    setShowExtraListModal(true);
  };

  const handleEditExtraTimeClick = (extra) => {
    setEditingExtraTime(extra);
    setEditExtraInTime(
      safeToDate(
        extra?.InTime
          ? (() => {
              const t = extra.InTime.split(":");
              const d = new Date();
              d.setHours(+t[0] || 0);
              d.setMinutes(+t[1] || 0);
              d.setSeconds(+t[2] || 0);
              return d;
            })()
          : null
      )
    );
    setEditExtraOutTime(
      safeToDate(
        extra?.OutTime
          ? (() => {
              const t = extra.OutTime.split(":");
              const d = new Date();
              d.setHours(+t[0] || 0);
              d.setMinutes(+t[1] || 0);
              d.setSeconds(+t[2] || 0);
              return d;
            })()
          : null
      )
    );
  };

  const handleUpdateExtraTime = () => {
    if (!editingExtraTime?.Id) {
      toast.error("Extra time record not found");
      return;
    }
    if (!editExtraInTime || !editExtraOutTime) {
      toast.error("Please select both In time and Out time");
      return;
    }

    const formattedInTime = moment(new Date(editExtraInTime)).format("HH:mm:ss");
    const formattedOutTime = moment(new Date(editExtraOutTime)).format("HH:mm:ss");
    const date = moment(editingExtraTime.Date).format("YYYY-MM-DD");
    const inMoment = moment(`${date} ${formattedInTime}`, "YYYY-MM-DD HH:mm:ss");
    const outMoment = moment(`${date} ${formattedOutTime}`, "YYYY-MM-DD HH:mm:ss");

    if (outMoment.isBefore(inMoment)) {
      toast.error("Out time should be greater than In time");
      return;
    }

    const payload = {
      id: Number(editingExtraTime.Id),
      userId: Number(editingExtraTime.UserId),
      date: moment(editingExtraTime.Date).format("YYYY-MM-DD"),
      inTime: formattedInTime,
      outTime: formattedOutTime,
    };

    setLoading(true);
    axios({
      method: "PUT",
      url: `${Apiurl()}/Attendence/UpdateExtraTime`,
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      data: payload,
    })
      .then((res) => {
        setLoading(false);
        toast.success(res?.data?.message || "Extra time updated successfully");
        setEditingExtraTime(null);
        setShowExtraListModal(false);
        handleAttendanceSearch({
          startDate: searchAttendance?.startDate,
          endDate: searchAttendance?.endDate,
          UserId: searchAttendance?.UserId,
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        } else {
          toast.error(error?.response?.data?.message || "Update failed");
        }
      });
  };

  const handleDeleteExtraTime = () => {
    if (!deleteExtraId) {
      toast.error("Extra time record not found");
      return;
    }
    setLoading(true);
    axios({
      method: "DELETE",
      url: `${Apiurl()}/Attendence/DeleteExtraTime/${deleteExtraId}`,
      headers: { authorization: `Bearer ${LoginToken}` },
    })
      .then((res) => {
        setLoading(false);
        toast.success(res?.data?.message || "Extra time deleted successfully");
        setShowDeleteExtraModal(false);
        setDeleteExtraId(null);
        setShowExtraListModal(false);
        setEditingExtraTime(null);
        handleAttendanceSearch({
          startDate: searchAttendance?.startDate,
          endDate: searchAttendance?.endDate,
          UserId: searchAttendance?.UserId,
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        } else {
          toast.error(error?.response?.data?.message || "Delete failed");
        }
      });
  };

  const confirmDailyStatusUpdate = () => {
    if (!selectedDailyStatus) {
      toast.error("Please select a status");
      return;
    }

    const payload = {
      Id: updateAttend.Id,
      UserName: updateAttend?.User?.UserName,
      DailyStatus: selectedDailyStatus,
      IsChangedByHr: true,
    };

    setLoading(true);
    axios({
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/SaveAttendance`,
      data: { data: JSON.stringify(payload) },
    })
      .then((e) => {
        setLoading(false);
        toast.success(e?.data?.message);
        setShowStatusModal(false);
        setShowFullDayConfirmation(false);
        setShowModal(false);
        setSelectedDailyStatus("");
        setupdateAttend(null);
        setmodaldata(null);
        setmodaldatanew(null);
        setIsWFH(false);
        handleAttendanceSearch({
          startDate: searchAttendance?.startDate,
          endDate: searchAttendance?.endDate,
          UserId: searchAttendance?.UserId,
        });
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
        setShowFullDayConfirmation(false);
      });
  };

  const handelAddExtraTime = () => {
    if (!IsExtraInTime || !IsExtraOutTime) {
      toast.error("Please select both In time and Out time");
      return;
    }

    const formattedInTime = moment(new Date(IsExtraInTime)).format("HH:mm:ss.SSS");
    const formattedOutTime = moment(new Date(IsExtraOutTime)).format("HH:mm:ss.SSS");
    const date = moment(updateAttend.Date).format("YYYY-MM-DD");
    const inMoment = moment(`${date} ${formattedInTime}`, "YYYY-MM-DD HH:mm:ss.SSS");
    const outMoment = moment(`${date} ${formattedOutTime}`, "YYYY-MM-DD HH:mm:ss.SSS");

    if (outMoment.isBefore(inMoment)) {
      toast.error("Out time should be greater than In time");
      return;
    }

    const data = {
      UserId: updateAttend.UserId,
      UserName: updateAttend?.User?.UserName,
      InTime: formattedInTime,
      OutTime: formattedOutTime,
      IsExtraTime: true,
      Date: updateAttend.Date,
      IsMainPunch: false,
    };

    setLoading(true);
    axios({
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/SaveAttendance`,
      data: { data: JSON.stringify(data) },
    })
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          CloseExtraTimeModal();
          handleAttendanceSearch({
            startDate: searchAttendance?.startDate,
            endDate: searchAttendance?.endDate,
            UserId: searchAttendance?.UserId,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handleAttendanceSearch = async (params = {}) => {
    const startDate =
      params?.startDate !== undefined
        ? params.startDate
        : searchAttendance?.startDate || "";

    const endDate =
      params?.endDate !== undefined
        ? params.endDate
        : searchAttendance?.endDate || "";

    const UserId =
      params?.UserId !== undefined
        ? params.UserId
        : searchAttendance?.UserId ?? null;

    if (startDate && endDate && endDate < startDate) {
      toast.error("End date should be greater than start date");
      setSearchAttendance((prev) => ({
        ...prev,
        endDate: "",
      }));
      return;
    }

    setLoading(true);

    try {
      const currentDateObj = new Date();
      const firstDayOfMonth = new Date(
        currentDateObj.getFullYear(),
        currentDateObj.getMonth(),
        1
      );

      const formattedStartDate = firstDayOfMonth.toISOString().split("T")[0];
      const formattedEndDate = currentDateObj.toISOString().split("T")[0];

      const payload = {
        startDate: startDate || formattedStartDate,
        endDate: endDate || formattedEndDate,
        UserId: UserId || null,
      };

      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          authorization: `Bearer ${LoginToken}`,
        },
        url: `${Apiurl()}/Attendence/GetAttendance`,
        data: { data: JSON.stringify(payload) },
      };

      const response = await axios(option);

      setLoading(false);
      setShow(false);

      if (response?.status === 200) {
        const parsedData = JSON.parse(response?.data?.data || "[]");

        const uniqueUsers = [];
        const userMap = new Map();

        parsedData.forEach((item) => {
          if (item?.UserId && item?.User?.UserName && !userMap.has(item.UserId)) {
            userMap.set(item.UserId, true);
            uniqueUsers.push({
              UserId: item.UserId,
              UserName: item.User.UserName,
            });
          }
        });

        setUserOptions(
          uniqueUsers.sort((a, b) => a.UserName.localeCompare(b.UserName))
        );

        const filteredAttendance = UserId
          ? parsedData.filter((item) => Number(item?.UserId) === Number(UserId))
          : parsedData;

        setGetAttendance(filteredAttendance);

        const groupedByUser = filteredAttendance.reduce((acc, item) => {
          if (!item?.UserId) return acc;

          if (!acc[item.UserId]) {
            acc[item.UserId] = [];
          }

          acc[item.UserId].push(item);
          return acc;
        }, {});

        const finalData = Object.values(groupedByUser).map((userRecords) =>
          userRecords.sort((a, b) => new Date(a.Date) - new Date(b.Date))
        );

        setDummyData(finalData);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Something went wrong");

      if (error?.response?.status === 401) {
        toast.error("Your session has expired");
        RemoveUserSession();
        navigate("/", { replace: true });
      }
    }
  };

  const handleUpdateAttendance = async () => {
    if (!updateAttend?.Id) {
      toast.error("Attendance record not found");
      return;
    }

    const inDate = safeToDate(Modaldata);
    const outDate = safeToDate(modaldatanew);

    const data = {
      Id: updateAttend?.Id,
      UserName: updateAttend?.User?.UserName,
      Date: updateAttend?.Date,
      InTime: null,
      OutTime: null,
      WorkDuration: null,
      Status: "Absent",
    };

    const formattedInTime = inDate ? moment(inDate).format("HH:mm:ss") : null;
    const formattedOutTime = outDate ? moment(outDate).format("HH:mm:ss") : null;

    data.InTime = formattedInTime;

    if (formattedInTime && !formattedOutTime) {
      data.OutTime = null;
      data.WorkDuration = null;
      data.Status = isWFH ? "WFH" : "Present";
    } else if (formattedInTime && formattedOutTime) {
      const inMoment = moment(inDate);
      const outMoment = moment(outDate);

      if (outMoment.isBefore(inMoment)) {
        toast.error("Out time should be greater than In time");
        return;
      }

      data.OutTime = formattedOutTime;

      const duration = moment.duration(outMoment.diff(inMoment));
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      data.WorkDuration = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

      data.Status = isWFH ? "WFH" : "Present";
    }

    setLoading(true);

    try {
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          authorization: `Bearer ${LoginToken}`,
        },
        url: `${Apiurl()}/Attendence/SaveAttendance`,
        data: { data: JSON.stringify(data) },
      };

      const response = await axios(option);

      setLoading(false);

      if (response?.status === 200) {
        toast.success(response?.data?.message || "Attendance updated successfully");
        setShowModal(false);
        setIsWFH(false);

        handleAttendanceSearch({
          startDate: searchAttendance?.startDate,
          endDate: searchAttendance?.endDate,
          UserId: searchAttendance?.UserId,
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Failed to update attendance");
    }
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }

    setShowSidebar(true);
  }, []);

  useEffect(() => {
    const hasStart = !!searchAttendance?.startDate;
    const hasEnd = !!searchAttendance?.endDate;

    if (hasStart && hasEnd) {
      setActiveButton(1);
      handleAttendanceSearch({
        startDate: searchAttendance?.startDate,
        endDate: searchAttendance?.endDate,
        UserId: searchAttendance?.UserId,
      });
    } else if (!hasStart && !hasEnd && !searchAttendance?.UserId) {
      setActiveButton(undefined);
      handleAttendanceSearch({
        startDate: "",
        endDate: "",
        UserId: null,
      });
    }
  }, [searchAttendance?.startDate, searchAttendance?.endDate]);

  useEffect(() => {
    if (dummyData?.length > 0) {
      const finalData = dummyData.filter(
        (item) =>
          Array.isArray(item) &&
          item.length > 0 &&
          item[0] &&
          item[0].Date
      );

      finalData.sort((a, b) => {
        const nameA = a?.[0]?.User?.UserName?.toLowerCase?.() || "";
        const nameB = b?.[0]?.User?.UserName?.toLowerCase?.() || "";
        return nameA.localeCompare(nameB);
      });

      setMonthResult(finalData);
    } else {
      setMonthResult([]);
    }
  }, [dummyData]);

  return (
    <>
      {loading ? <Loader /> : null}

      <div>
        <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

        <div className="d-flex">
          <Sidebar showSidebar={showSidebar} />

          <div
            className={
              showSidebar
                ? "EMP-main-container-of-all-employees-sheet-hr"
                : "EMP-main-container-of-all-employees-page-new-sheet"
            }
          >
            <div className="EMP-inner-container-of-all-employees-page">
              <div className="header-of-employees-page row">
                <div className="EMP-all-employee-sheet col">
                  <h4>Employee Attendance Sheet</h4>

                  <OffCanvasExample
                    currentDate={currentDate}
                    setActiveButton={setActiveButton}
                    handleAttendanceSearch={handleAttendanceSearch}
                    setSearchAttendance={setSearchAttendance}
                    setShow={setShow}
                    show={show}
                    searchAttendance={searchAttendance}
                    activeButton={activeButton}
                    userOptions={userOptions}
                    placement="bottom"
                  />
                </div>

                <div className="EMP-all-employees-sheet col">
                  <div className="EMP-home-icon-sheet">
                    <BiHomeAlt className="EMP-home-icon-header-sheet" />
                  </div>
                  <div className="EMP-arrow-icon-sheet">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="EMP-employee-text-sheet">
                    <p>Attendance</p>
                  </div>
                  <div className="EMP-arrow-icon-sheet">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="EMP-all-employee-text-sheet">
                    <p>Attendance Sheet</p>
                  </div>
                </div>
              </div>

              <div>
                <div className="top-legends-main">
                  <div className="legends-section">
                    <div className="legend-item status-present">Present</div>
                    <div className="legend-item status-absent">Absent</div>
                    <div className="legend-item status-holiday">Holiday</div>
                    <div className="legend-item status-weekoff">Weekly Off</div>
                    <div className="legend-item status-sick">Sick Leave</div>
                    <div className="legend-item status-casual">Casual Leave</div>
                    <div className="legend-item status-halfday">Half Day</div>
                    <div className="legend-item status-shortleave">Short Leave</div>
                    <div className="legend-item status-shortwork">Short Work</div>
                    <div className="legend-item status-outdoor">Outdoor Duty</div>
                  </div>
                </div>

                <div className="EMP-table-in-all-emplyee-sheet">
                  <div className="calender-in-header row">
                    <div className="col-3">
                      <div className="EMP-flash-floating-sheet col">
                        <label>Select User</label>
                        <select
                          className="attendance-select-field"
                          value={searchAttendance?.UserId || ""}
                          onChange={(e) => {
                            const selectedUserId = e.target.value
                              ? Number(e.target.value)
                              : null;

                            setSearchAttendance((prev) => ({
                              ...prev,
                              UserId: selectedUserId,
                            }));

                            setActiveButton(1);

                            handleAttendanceSearch({
                              startDate: searchAttendance?.startDate,
                              endDate: searchAttendance?.endDate,
                              UserId: selectedUserId,
                            });
                          }}
                        >
                          <option value="">All Users</option>
                          {userOptions?.map((user) => (
                            <option key={user.UserId} value={user.UserId}>
                              {user.UserName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-3">
                      <div className="EMP-flash-floating-sheet col">
                        <label>Choose start date</label>
                        <input
                          type="date"
                          value={searchAttendance?.startDate}
                          onChange={(e) =>
                            setSearchAttendance((prev) => ({
                              ...prev,
                              startDate: e?.target?.value,
                            }))
                          }
                          max={currentDate}
                        />
                      </div>
                    </div>

                    <div className="col-3">
                      <div className="flash-floating-sheet col">
                        <label>Choose end date</label>
                        <input
                          type="date"
                          value={searchAttendance?.endDate}
                          onChange={(e) =>
                            setSearchAttendance((prev) => ({
                              ...prev,
                              endDate: e?.target?.value,
                            }))
                          }
                          min={searchAttendance?.startDate}
                          max={currentDate}
                        />
                      </div>
                    </div>

                    <div className="EMP-search-button-sheet col-3">
                      {activeButton ||
                      searchAttendance?.startDate ||
                      searchAttendance?.endDate ||
                      searchAttendance?.UserId ? (
                        <div className="EMP-search-button-sheet col-12">
                          <button
                            onClick={() => {
                              setSearchAttendance({
                                startDate: "",
                                endDate: "",
                                UserId: null,
                              });
                              setActiveButton(undefined);
                              handleAttendanceSearch({
                                startDate: "",
                                endDate: "",
                                UserId: null,
                              });
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="EMP-table-all-content-sheet">
                    {monthResult?.length > 0 ? (
                      monthResult.map((e, index) => {
                        if (!Array.isArray(e) || e.length === 0 || !e?.[0]?.Date) {
                          return null;
                        }

                        return (
                          <Fragment key={index}>
                            <div className="months-heading-for-table">
                              <p>{getMonthLabel(e)}</p>
                            </div>

                            <table className="EMP-table-main-class">
                              <thead className="EMP-thead-main-class">
                                <tr>
                                  <th>{e?.[0]?.User?.UserName || "-"}</th>

                                  {groupByDateWithPunch(e)?.map((group, idx) => {
                                    const item = group.main || group.extras[0];
                                    if (!item) return null;

                                    return (
                                      <td
                                        key={idx}
                                        className="date-and-day-data"
                                        style={{ position: "relative" }}
                                      >
                                        {new Date(item.Date).toLocaleDateString(
                                          "en-US",
                                          {
                                            weekday: "short",
                                            day: "numeric",
                                          }
                                        )}

                                        {group.extras.length > 0 && (
                                          <div
                                            className="extra-count-badge"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              openExtraTimeListModal(group.extras)
                                            }
                                          >
                                            +{group.extras.length}
                                          </div>
                                        )}

                                        <p onClick={() => handlePencilClick(item)}>
                                          <FaEdit className="edit-icon-hr" />
                                        </p>
                                      </td>
                                    );
                                  })}
                                </tr>
                              </thead>

                              <tbody className="EMP-tbody-main-class">
                                <tr>
                                  <td className="input-class-in-td-main">
                                    <p className="attendance-label">Attendance</p>
                                    <p className="in-time-label">In time</p>
                                    <p className="outtime-label">Out time</p>
                                  </td>

                                  {groupByDateWithPunch(e)?.map((group, idx) => {
                                    const item = group.main || group.extras[0];
                                    if (!item) return null;

                                    const statusClass = getStatusClass(
                                      item?.DailyStatus || item?.Status
                                    );

                                    return (
                                      <td
                                        key={idx}
                                        className={`attendance-cell ${statusClass}`}
                                      >
                                        <p
                                          className="intime-for-attendance"
                                          style={{
                                            color:
                                              !item?.DailyStatus ||
                                              item?.DailyStatus === ""
                                                ? "black"
                                                : "white",
                                          }}
                                        >
                                          {item?.InTime
                                            ? item?.InTime.substring(0, 5)
                                            : "-"}
                                        </p>

                                        <p
                                          className="out-for-attendance"
                                          style={{
                                            color:
                                              !item?.DailyStatus ||
                                              item?.DailyStatus === ""
                                                ? "black"
                                                : "white",
                                          }}
                                        >
                                          {item?.InTime && item?.OutTime
                                            ? item?.OutTime.substring(0, 5)
                                            : "-"}
                                        </p>
                                      </td>
                                    );
                                  })}
                                </tr>
                              </tbody>
                            </table>
                          </Fragment>
                        );
                      })
                    ) : (
                      <div className="text-center p-3">No attendance data found</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Time Modal */}
      <div className="modal show" style={{ display: "block", position: "initial" }}>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header className="empAttendance" closeButton>
            <Modal.Title>Edit time</Modal.Title>
          </Modal.Header>

          <Modal.Body className="employee-Modal-body">
            <div>
              <div>
                <label>Date</label>
              </div>

              <div className="modal-DatePicker">
                <DatePicker
                  containerClassName="containerclass"
                  value={updateAttend?.Date ? new Date(updateAttend.Date) : ""}
                  onChange={() => {}}
                />
              </div>
            </div>

            <div className="update-attendance-time">
              <div>
                <label>In time</label>
                <DatePicker
                  containerClassName="time-change-in-hr-side"
                  value={Modaldata}
                  format="hh:mm A"
                  plugins={[<TimePicker key="in-time-picker" />]}
                  disableDayPicker
                  onChange={(date) => setmodaldata(safeToDate(date))}
                />
              </div>

              <div>
                <label>Out time</label>
                <DatePicker
                  plugins={[<TimePicker key="out-time-picker" />]}
                  format="hh:mm A"
                  containerClassName="time-change-in-hr-side"
                  value={modaldatanew}
                  disableDayPicker
                  onChange={(date) => setmodaldatanew(safeToDate(date))}
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="empAttendance-footer">
            <div className="Work-from-home-container">
              <label>WFH</label>
              <input
                type="checkbox"
                checked={isWFH}
                onChange={(e) => setIsWFH(e.target.checked)}
              />
            </div>

            <button
              className="AddExtraTime-button"
              onClick={() => setshowExtraTimePopup(true)}
            >
              Add Extra Time
            </button>

            <button
              className="handleCloseModal-button"
              onClick={() => setShowStatusModal(true)}
            >
              Change Status
            </button>

            <button
              className="handleUpdateAttendance-button"
              onClick={handleUpdateAttendance}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
      </div>

      {/* Add Extra Time Modal */}
      <div className="modal show" style={{ display: "block", position: "initial" }}>
        <Modal show={showExtraTimePopup} onHide={CloseExtraTimeModal}>
          <Modal.Header className="empAttendance" closeButton>
            <Modal.Title>Add Extra Time</Modal.Title>
          </Modal.Header>
          <Modal.Body className="employee-Modal-body">
            <div>
              <label>Date</label>
              <div className="modal-DatePicker">
                <DatePicker
                  containerClassName="containerclass"
                  value={updateAttend?.Date ? new Date(updateAttend.Date) : ""}
                  onChange={() => {}}
                />
              </div>
            </div>
            <div className="update-attendance-time">
              <div>
                <label>In time</label>
                <DatePicker
                  containerClassName="time-change-in-hr-side"
                  value={IsExtraInTime}
                  format="hh:mm A"
                  plugins={[<TimePicker key="extraIn" />]}
                  disableDayPicker
                  onChange={(date) => setIsExtraInTime(new Date(date))}
                />
              </div>
              <div>
                <label>Out time</label>
                <DatePicker
                  plugins={[<TimePicker key="extraOut" />]}
                  format="hh:mm A"
                  containerClassName="time-change-in-hr-side"
                  value={IsExtraOutTime}
                  disableDayPicker
                  onChange={(date) => setIsExtraOutTime(new Date(date))}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="empAttendance-footer">
            <button className="handleCloseModal-button" onClick={CloseExtraTimeModal}>
              Close
            </button>
            <button className="handleUpdateAttendance-button" onClick={handelAddExtraTime}>
              Save
            </button>
          </Modal.Footer>
        </Modal>
      </div>

      {/* Extra Time List Modal */}
      <div className="modal show" style={{ display: "block", position: "initial" }}>
        <Modal
          show={showExtraListModal}
          onHide={() => {
            setShowExtraListModal(false);
            setEditingExtraTime(null);
          }}
          centered
          size="lg"
        >
          <Modal.Header className="empAttendance" closeButton>
            <Modal.Title>Extra Time Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="employee-Modal-body">
            {!editingExtraTime ? (
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>In Time</th>
                    <th>Out Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedExtraList?.length > 0 ? (
                    selectedExtraList.map((extra, index) => (
                      <tr key={extra.Id}>
                        <td>{index + 1}</td>
                        <td>
                          {extra?.Date ? moment(extra.Date).format("YYYY-MM-DD") : "-"}
                        </td>
                        <td>{extra?.InTime ? extra.InTime.substring(0, 5) : "-"}</td>
                        <td>
                          {extra?.OutTime ? extra.OutTime.substring(0, 5) : "-"}
                        </td>
                        <td>
                          <button
                            className="handleUpdateAttendance-button"
                            style={{ marginRight: "8px" }}
                            onClick={() => handleEditExtraTimeClick(extra)}
                          >
                            Edit
                          </button>
                          <button
                            className="handleCloseModal-button"
                            onClick={() => {
                              setDeleteExtraId(extra.Id);
                              setShowDeleteExtraModal(true);
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        No extra time found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              <>
                <div>
                  <label>Date</label>
                  <div className="modal-DatePicker">
                    <DatePicker
                      containerClassName="containerclass"
                      value={
                        editingExtraTime?.Date ? new Date(editingExtraTime.Date) : ""
                      }
                      onChange={() => {}}
                    />
                  </div>
                </div>
                <div className="update-attendance-time">
                  <div>
                    <label>In time</label>
                    <DatePicker
                      containerClassName="time-change-in-hr-side"
                      value={editExtraInTime}
                      format="hh:mm A"
                      plugins={[<TimePicker key="editExtraIn" />]}
                      disableDayPicker
                      onChange={(date) => setEditExtraInTime(new Date(date))}
                    />
                  </div>
                  <div>
                    <label>Out time</label>
                    <DatePicker
                      containerClassName="time-change-in-hr-side"
                      value={editExtraOutTime}
                      format="hh:mm A"
                      plugins={[<TimePicker key="editExtraOut" />]}
                      disableDayPicker
                      onChange={(date) => setEditExtraOutTime(new Date(date))}
                    />
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="empAttendance-footer">
            {editingExtraTime ? (
              <>
                <button
                  className="handleCloseModal-button"
                  onClick={() => setEditingExtraTime(null)}
                >
                  Back
                </button>
                <button
                  className="handleUpdateAttendance-button"
                  onClick={handleUpdateExtraTime}
                >
                  Update
                </button>
              </>
            ) : (
              <button
                className="handleCloseModal-button"
                onClick={() => setShowExtraListModal(false)}
              >
                Close
              </button>
            )}
          </Modal.Footer>
        </Modal>
      </div>

      {/* Delete Extra Time Confirmation Modal */}
      <div className="modal show" style={{ display: "block", position: "initial" }}>
        <Modal
          show={showDeleteExtraModal}
          onHide={() => {
            setShowDeleteExtraModal(false);
            setDeleteExtraId(null);
          }}
        >
          <Modal.Header className="empAttendance" closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body className="employee-Modal-body">
            <p>Are you sure you want to delete this extra time?</p>
          </Modal.Body>
          <Modal.Footer className="empAttendance-footer">
            <button
              className="handleCloseModal-button"
              onClick={() => {
                setShowDeleteExtraModal(false);
                setDeleteExtraId(null);
              }}
            >
              No
            </button>
            <button
              className="handleUpdateAttendance-button"
              onClick={handleDeleteExtraTime}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
      </div>

      {/* Change Status Modal */}
      <div className="modal show" style={{ display: "block", position: "initial" }}>
        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header className="empAttendance" closeButton>
            <Modal.Title>Change Daily Status</Modal.Title>
          </Modal.Header>
          <Modal.Body className="employee-Modal-body">
            <select
              className="dailyStatus-select"
              value={selectedDailyStatus}
              onChange={(e) => setSelectedDailyStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="FullDay">FullDayWorking</option>
              <option value="HalfDayleave">HalfDayleave</option>
              <option value="ShortLeave">ShortLeave</option>
              <option value="ThreeQuareterLeave">ThreeQuareterLeave</option>
              <option value="Absent">Absent</option>
            </select>
          </Modal.Body>
          <Modal.Footer className="empAttendance-footer">
            <button
              className="handleUpdateAttendance-button"
              onClick={() => setShowFullDayConfirmation(true)}
            >
              Update
            </button>
          </Modal.Footer>
        </Modal>
      </div>

      {/* Confirm Status Change Modal */}
      <div className="modal show" style={{ display: "block", position: "initial" }}>
        <Modal
          show={showFullDayConfirmation}
          onHide={() => setShowFullDayConfirmation(false)}
        >
          <Modal.Header className="empAttendance" closeButton>
            <Modal.Title>Confirm Attendance Change</Modal.Title>
          </Modal.Header>
          <Modal.Body className="employee-Modal-body">
            <p>Are you sure you want to change the attendance?</p>
          </Modal.Body>
          <Modal.Footer className="empAttendance-footer">
            <button
              className="handleCloseModal-button"
              onClick={() => setShowFullDayConfirmation(false)}
            >
              No
            </button>
            <button
              className="handleUpdateAttendance-button"
              onClick={confirmDailyStatusUpdate}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default AttendanceSheet;